import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => ({
  Box: {
    width: "100%",
    backgroundColor: "#d7dde0",
  },
  topic: {
    fontSize: "30px",
    color: "#183d78",
    marginLeft: "30%",
    fontWeight: "bold",
    //marginTop: 10,
  },
  table: {
    minWidth: 700,
    paddingLeft: 50,
  },
  paper: {
    marginLeft: 150,
    width: "70%",
    backgroundColor: "#d7dde0",
    marginBottom: "11%",
  },
  testBtn: {
    marginLeft: "64%",
    paddingTop: "3%",
  },
  content: {
    fontSize: "20px",
    color: "#183d78",
    fontWeight: "medium",
  },
  testBtn2: {
    marginLeft: 65,
    paddingTop: "3%",
  },
  text: {
    marginLeft: "28%",
  },
  content2: {
    fontSize: "20px",
    color: "#183d78",
    fontWeight: "medium",
    marginLeft: "35%",
  },
}));

export default useStyles;

// sx={{
//   width: "100%",
//   backgroundColor: "#d7dde0",
//   padding: 3,
// }}
